<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :actions="$route.params.id ? actions : []"
    :form="form"
    :title="type === 'index' ? $t('menu.createEvent') : $t('model.ticketEvent')"
    resource="ticket_events"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import { filterColumnsExtend, columnsExtend, formColumnsExtend } from '../admin_grapes/ticket_events.js';
import _ from 'lodash';

@Component
export default class TicketEvents extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  filterColumns() {
    const array = [
      'title_cont',
      'is_show_eq',
    ].filter(Boolean)

    return filterColumnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -RESTful api resource name
   */
  columns(h, { type }) {
    const array = [
      type === 'show' && 'id',
      'title',
      'serial_code',
      {
        key: 'tag_list',
        minWidth: 150,
        renderCell: (h, { props: { value } }) => {
          return (_.map(value, (tag) => (<el-tag style={{ 'margin-right': '3px' }}>{tag.length > 10 ? (tag.slice(0, 10) + '...') : tag}</el-tag>)))
        }
      },
      'start_at',
      'end_at',
      type === 'show' && 'business_hours',
      type === 'show' && 'address1',
      type === 'show' && 'address2',
      type === 'show' && 'location',
      'is_show',
      type === 'show' && { key: 'introduction' },
      type === 'show' && { key: 'faq' },
      'cover',
      type === 'show' && 'posters',
      type === 'show' && 'created_at',
      type === 'show' && 'updated_at',
    ].filter(Boolean)

    return columnsExtend(array)
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - page type enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource - RESTful api resoure name
   * @param {Object} params.data - current form data
   * @param {Function} params.change - invoke this method to sync form change({ field: 'new value' })
   */
  formColumns(h, { data, type }) {
    const array = [
      'title',
      {
        prop: 'tag_list',
        label: this.$t('ticketEvent.tagList'),
        renderCell: {
          component: 'select',
          domProps: { style: 'width: 100%' },
          props: {
            clearable: true,
            multiple: true,
            filterable: true,
            xRemotePreload: async () => {
              const data = await this.$request.get('acts_as_taggable_on/tags/read_options', { page: 0, kind_eq: "ticket_event" })
              return _.map(data, ({ name }) => ({ value: name, label: name }))
            }
          }
        }
      },
      'start_at',
      'end_at',
      'business_hours',
      'address1',
      'address2',
      'location',
      'introduction',
      'faq',
      {
        key: 'cover',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 300x300`,
        }
      },
      {
        key: 'posters',
        renderCell: {
          hint: `${this.$t('suggestSize')}: 600x600`,
          props: {
            limit: 9,
          }
        }
      },
    ].filter(Boolean)

    return formColumnsExtend(array, { data: data, type: type })
  }

  /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions({ row }, { remove, reload }) {
    return [
      {
        component: 'routeButton',
        props: {
          label: this.$t('edit'),
          to: { name: 'ticket_events.edit', params: { id: row.id } }
        }
      },
      !row.is_show && {
        component: 'confirmButton',
        props: {
          label: this.$t('show'),
          type: 'primary',
          can: 'ticket_events.update',
        },
        on: {
          confirm: async () => {
            await this.$request.put(`/ticket_events/${row.id}/is_show_to_true`);
            this.$message.success(this.$t('bean.operateSuccess'));
            reload();
          }
        }
      },
      row.is_show && {
        component: 'confirmButton',
        props: {
          label: this.$t('hide'),
          type: 'danger',
          can: 'ticket_events.update',
        },
        on: {
          confirm: async () => {
            await this.$request.put(`/ticket_events/${row.id}/is_show_to_false`);
            this.$message.success(this.$t('bean.operateSuccess'));
            reload();
          }
        }
      },
      {
        component: 'confirmButton',
        props: {
          label: this.$t('destroy'),
          type: 'danger',
          can: 'ticket_events.destroy'
        },
        on: {
          confirm: () => remove(row.id)
        }
      }
    ].filter(Boolean);
  }
}

export const route = [
  {
    path: '/ticket_events',
    name: 'ticket_events.index',
    component: TicketEvents,
    props: {
      type: 'index',
    }
  },
  {
    path: '/ticket_events/new',
    name: 'ticket_events.new',
    component: TicketEvents,
    props: {
      type: 'new',
    }
  },
  {
    path: '/ticket_events/:id',
    name: 'ticket_events.show',
    component: TicketEvents,
    props: {
      type: 'show',
    }
  },
  {
    path: '/ticket_events/:id/edit',
    name: 'ticket_events.edit',
    component: TicketEvents,
    props: {
      type: 'edit'
    }
  }
]
</script>
